import "core-js/features/url-search-params";
import "core-js/features/promise";

import Vue from "vue";
import vueCustomElement from "vue-custom-element";
import BexHeader from "./BexHeader";
import BexFooter from "./BexFooter";

Vue.config.productionTip = true;

Vue.use(vueCustomElement);

Vue.customElement("bex-header", BexHeader);
Vue.customElement("bex-footer", BexFooter);
